var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useContactManagementTranslation } from '../../../../../ui/hooks';
import { DataTable, TextCell } from '@juvare/common-data-table-ui/DataTable';
import { FiltersBar, useFilterConfig } from '@juvare/common-data-table-ui/FiltersBar';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { Box } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { useDataTablePagination } from '../../hooks/useDataTablePagination';
export const SelectFieldsStep = React.forwardRef((props, ref) => {
    var _a;
    const { t } = useContactManagementTranslation();
    const { accountExport } = useSelector(getSettings);
    const data = accountExport.map((columns) => (Object.assign(Object.assign({}, columns), { id: `${columns.headerName}-${columns.type}-${'source' in columns ? `${columns.source}` : ''}` })));
    const [fields, setFields] = React.useState(data);
    const [selectedFieldIds, setSelectedFieldIds] = React.useState((_a = props.defaultFieldIds) !== null && _a !== void 0 ? _a : data.filter((field) => field.default).map(({ id }) => id));
    const filterConfig = useFilterConfig((builder) => {
        builder.quickSearchFilter({
            dataPath: 'search',
            label: t('common.search'),
        });
    }, [t]);
    const pagination = useDataTablePagination({ data: fields });
    const handleFilterFields = (filterData) => {
        if (filterData.search) {
            setFields(data.filter(({ headerName }) => headerName.toLowerCase().includes(filterData.search.toLowerCase())));
        }
        else {
            setFields(data);
        }
    };
    const handleRowSelectionChange = (row) => {
        setSelectedFieldIds((prev) => {
            if (prev.includes(row.id)) {
                return prev.filter((selectedFieldId) => selectedFieldId !== row.id);
            }
            else {
                return [...prev, row.id];
            }
        });
    };
    const handleOnSelectAllRowsInCurrentPageClick = (_, selected) => {
        if (selected) {
            setSelectedFieldIds(data.map(({ id }) => id));
        }
        else {
            setSelectedFieldIds([]);
        }
    };
    const selectedFields = selectedFieldIds.map((selectedFieldId) => data.find((fields) => fields.id === selectedFieldId));
    React.useImperativeHandle(ref, () => ({
        getData: () => ({
            selectedFields,
        }),
        submit: () => __awaiter(void 0, void 0, void 0, function* () {
            if (selectedFieldIds.length) {
                const response = yield props.onSubmit({ selectedFields });
                return props.onSubmitSuccess({ selectedFields }, response);
            }
            else {
                return Promise.reject(t('export.noFieldSelected'));
            }
        }),
    }));
    return (React.createElement(Box, { bgcolor: themeColors.surface.secondary, p: 2 },
        React.createElement(DataTable, Object.assign({ columns: [
                { headerLabel: t('export.fieldName'), cellFunction: ({ headerName }) => React.createElement(TextCell, null, headerName) },
                {
                    headerLabel: t('export.type'),
                    cellFunction: ({ type }) => React.createElement(TextCell, null, type),
                },
            ], filtersBar: React.createElement(FiltersBar, { config: filterConfig, onFilter: handleFilterFields }), loading: false, rowSelectionEnabled: true, filteredRowCount: fields.length, onRowSelectionChange: handleRowSelectionChange, onSelectAllRowsInCurrentPageClick: handleOnSelectAllRowsInCurrentPageClick, selectedRowIds: selectedFieldIds }, pagination))));
});
